import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PublicSite from "@/pages/PublicSite";
import CrashSignals from "@/pages/CrashSignals";
import TermsOfUse from "@/pages/TermsOfUse";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import { AdminApp } from "@/admin/AdminApp";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicSite />} />
          <Route path="/crash" element={<CrashSignals />} />
          <Route path="/termos-de-uso" element={<TermsOfUse />} />
          <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
          <Route path="/admin/*" element={<AdminApp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
